import { render } from "./ButtonAddToCart.vue?vue&type=template&id=73982e17&ts=true"
import script from "./ButtonAddToCart.vue?vue&type=script&lang=ts"
export * from "./ButtonAddToCart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__